import {
	AmountOfTaxArrearsField,
	AreaAffectedByTheEasementField,
	CondoFeeAsApsField,
	CondoFeeAsOnStatusCertificateField,
	DateOfRegistrationField,
	EncumbranceTypeField,
	HoldbackAmountField,
	CloserDefaultRequisitionPrecedent,
	InstrumentAmountField,
	InstrumentNumberField,
	InstrumentNumberOfMortgageBenefitingFromPostponementField,
	InstrumentNumberOfMortgagePostponedField,
	InstrumentNumberOfTransferOfChargeField,
	JurisdictionDepartmentTypeField,
	NameOfEstateField,
	NameOfOtherMortgageField,
	NameOfOwnerField,
	NameOfVendorField,
	NameUsedForSearchField,
	NamesAsOnApsField,
	NamesAsOnTitleField,
	NumberOfExecutionsField,
	ParticularsOfEncumbranceField,
	PartyFromField,
	PartyToField,
	PostPonementInstrumentNumberField,
	PreambleField,
	RegionField,
	RegistrationDateForPostponementField,
	RegistrationDateOfTransferOfChargeField,
	RegistrationNumberOfVendorsMortgageField,
	RequirementsField,
	RequisitionPrecedentIds,
	TransfereeInTransferOfChargeField,
} from '@models/requisitions';

export const requisitions: CloserDefaultRequisitionPrecedent[] = [
	{
		id: RequisitionPrecedentIds.UTILITY_SEARCH,
		closerDefault: true,
		version: 1,
		name: 'Utility search',
		fields: {
			[InstrumentAmountField.name]: InstrumentAmountField,
			[JurisdictionDepartmentTypeField.name]: JurisdictionDepartmentTypeField,
		},
		text: 'Enclosed is a copy of the {{requisitions.id.fields.departmentType}} certificate obtained by our office that shows arrears in the amount of {{requisitions.id.fields.instrumentAmount.formatted}}',
		requisitionText:
			"REQUIRED: On or before closing, production and evidence of your firm's undertaking to pay to the {{requisitions.id.fields.departmentType}} department, forthwith upon completion of this transaction, the sum of {{requisitions.id.fields.instrumentAmount.formatted}}, an amount sufficient to pay{{#iff requisitions.id.fields.departmentType 'equals' 'Tax'}} taxes including any{{/iff}} arrears and penalty to the end of closing date or end of closing date month.",
		source: '',
		isOnTitle: false,
	},
	{
		id: RequisitionPrecedentIds.GENERIC_INSTRUMENT,
		closerDefault: true,
		version: 1,
		name: 'Generic instrument',
		fields: {
			[InstrumentNumberField.name]: InstrumentNumberField,
			[EncumbranceTypeField.name]: EncumbranceTypeField,
			[DateOfRegistrationField.name]: DateOfRegistrationField,
			[PartyFromField.name]: PartyFromField,
			[PartyToField.name]: PartyToField,
			[RequirementsField.name]: RequirementsField,
		},
		text: 'Instrument no. {{ requisitions.id.fields.instrumentNumber }} is a/an {{ requisitions.id.fields.encumbranceType }} registered on {{ requisitions.id.fields.registrationDate }} from {{ requisitions.id.fields.partyFrom }} in favour of {{ requisitions.id.fields.partyTo }}.',
		requisitionText:
			'REQUIRED: On or before closing, {{ requisitions.id.fields.requirements }}.',
		source: '',
		isOnTitle: true,
	},
	{
		id: RequisitionPrecedentIds.CHARGE,
		closerDefault: true,
		version: 2,
		name: 'Charge',
		fields: {
			[InstrumentNumberField.name]: InstrumentNumberField,
			[EncumbranceTypeField.name]: EncumbranceTypeField,
			[DateOfRegistrationField.name]: DateOfRegistrationField,
			[PartyFromField.name]: PartyFromField,
			[PartyToField.name]: PartyToField,
			[InstrumentAmountField.name]: InstrumentAmountField,
		},
		text: 'Instrument No. {{ requisitions.id.fields.instrumentNumber }} is a/an {{ requisitions.id.fields.encumbranceType }} registered on {{ requisitions.id.fields.registrationDate }} from {{ requisitions.id.fields.partyFrom }} in favour of {{ requisitions.id.fields.partyTo }} securing the principal sum of {{ requisitions.id.fields.instrumentAmount.formatted }}.',
		requisitionText:
			'REQUIRED: On or before closing, production and registration of a good and valid discharge of this Mortgage. \n If you do not have the discharge of Mortgage on the closing date we will require a copy of the discharge statement from {{ requisitions.id.fields.partyTo }} showing the balance outstanding as of the closing date, a direction to make funds payable to {{ requisitions.id.fields.partyTo }}, and your firm undertaking to obtain and register a good and valid discharge of said Mortgage.',
		source: '',
		isOnTitle: true,
	},
	{
		id: RequisitionPrecedentIds.CHARGE_POWER_OF_SALE,
		closerDefault: true,
		version: 1,
		name: 'Charge (power of sale)',
		fields: {
			[InstrumentNumberField.name]: InstrumentNumberField,
			[InstrumentAmountField.name]: InstrumentAmountField,
			[EncumbranceTypeField.name]: EncumbranceTypeField,
			[DateOfRegistrationField.name]: DateOfRegistrationField,
			[PartyFromField.name]: PartyFromField,
			[PartyToField.name]: PartyToField,
			[NameOfVendorField.name]: NameOfVendorField,
			[RegistrationNumberOfVendorsMortgageField.name]:
				RegistrationNumberOfVendorsMortgageField,
			[ParticularsOfEncumbranceField.name]: ParticularsOfEncumbranceField,
		},
		text: 'Instrument No. {{ requisitions.id.fields.instrumentNumber }} is a/an {{ requisitions.id.fields.encumbranceType }} registered on {{ requisitions.id.fields.registrationDate }} from {{ requisitions.id.fields.partyFrom }} in favour of {{ requisitions.id.fields.partyTo }} securing the principal sum of {{ requisitions.id.fields.instrumentAmount.formatted }}.',
		requisitionText:
			'REQUIRED: According to the Agreement of Purchase and Sale, the property is being sold to our client under Power of Sale by {{ requisitions.id.fields.vendorName }}, and it is therefore assumed that your client is selling the property pursuant to the mortgage registered as Instrument No. {{ requisitions.id.fields.vendorsMortgageRegistrationNumber }} \n On or before closing, that the following liens or encumbrances be paid off and discharged or that the rights of the holders thereof be extinguished by virtue of the Power of Sale proceedings: \n {{ requisitions.id.fields.encumbranceParticulars }} \n FURTHER REQUIRED: At least 15 days prior to closing, drafts of documentation to be registered setting out particulars of the exercise of the Power of Sale and evidencing compliance with The Mortgages Act.  All such documentation should be submitted to the Registrar for pre-approval well in advance of the closing date.  Without limiting the generality of the foregoing, such documentation shall include: \n (i) a statutory declaration by the mortgagee selling under Power of Sale confirming the default, including its date of occurrence as well as verification that it continues to the date of closing of the within sale; \n (ii) a statutory declaration proving service, including production and registration of the original post office receipts for the registered mail; \n (iii) a statutory declaration by the mortgagee, its solicitor or agent that the sale complies with Part III and if applicable, Part II of The Mortgages Act; and \n (iv) a statutory declaration by the mortgagee that the sale complies with The Family Law Act, and with section 116 of the Income Tax Act of Canada.',
		source: '',
		isOnTitle: true,
	},
	{
		id: RequisitionPrecedentIds.EXECUTION,
		closerDefault: true,
		version: 1,
		name: 'Execution',
		fields: {
			[NameUsedForSearchField.name]: NameUsedForSearchField,
			[NumberOfExecutionsField.name]: NumberOfExecutionsField,
		},
		text: ' Our search of executions against the name {{ requisitions.id.fields.searchTextName }} disclosed the existence of the {{ requisitions.id.fields.executionsNumber }} execution(s) against such person (or similar name), particulars of which have been enclosed herewith for your convenience.',
		requisitionText:
			"REQUIRED: On or before closing, satisfaction of the above execution(s) together with costs and the withdrawal thereof from the files of the Director of Titles.  In the alternative, if the debtor is not one and the same person as {{ requisitions.id.fields.searchTextName }} , at least 15 days prior to closing, production of a draft of documentation to be registered including the proper electronic statements to satisfy both the writer and the Director of Titles.  Please note that an individual's statement will be acceptable if the principal amount of the writ is less than $50,000.00.  If the principal amount is more, a solicitor's statement or a statement by the judgment creditor will be required.",
		source: '',
		isOnTitle: false,
	},
	{
		id: RequisitionPrecedentIds.RESTRICTIVE_COVENANTS_ON_TITLE,
		closerDefault: true,
		version: 1,
		name: 'Restrictive covenants on title',
		fields: {
			[InstrumentNumberField.name]: InstrumentNumberField,
			[EncumbranceTypeField.name]: EncumbranceTypeField,
			[DateOfRegistrationField.name]: DateOfRegistrationField,
			[PartyFromField.name]: PartyFromField,
			[PartyToField.name]: PartyToField,
		},
		text: ' Instrument no. {{ requisitions.id.fields.instrumentNumber }} is a/an {{ requisitions.id.fields.encumbranceType }} registered on {{ requisitions.id.fields.registrationDate }} from {{ requisitions.id.fields.partyFrom }} in {{ requisitions.id.fields.partyTo }}.',
		requisitionText:
			'REQUIRED: On or before closing: \n a) production and delivery of evidence that the said Covenants have been complied with in full to date, and \n b) deletion of said Covenants from title to the subject property.',
		source: '',
		isOnTitle: true,
	},
	{
		id: RequisitionPrecedentIds.ASSIGNMENT_OF_RENTS,
		closerDefault: true,
		version: 1,
		name: 'Assignment of rents',
		fields: {
			[InstrumentNumberField.name]: InstrumentNumberField,
			[EncumbranceTypeField.name]: EncumbranceTypeField,
			[DateOfRegistrationField.name]: DateOfRegistrationField,
			[PartyFromField.name]: PartyFromField,
			[PartyToField.name]: PartyToField,
		},
		text: 'Instrument no. {{ requisitions.id.fields.instrumentNumber }} is a/an {{ requisitions.id.fields.encumbranceType }} registered on {{ requisitions.id.fields.registrationDate }} from {{ requisitions.id.fields.partyFrom }} in favour of {{ requisitions.id.fields.partyTo }}.',
		requisitionText:
			'REQUIRED: On or before closing, deletion of this Assignment of Rents from title to the subject property.',
		source: '',
		isOnTitle: true,
	},
	{
		id: RequisitionPrecedentIds.LIEN,
		closerDefault: true,
		version: 1,
		name: 'Lien',
		fields: {
			[InstrumentNumberField.name]: InstrumentNumberField,
			[EncumbranceTypeField.name]: EncumbranceTypeField,
			[DateOfRegistrationField.name]: DateOfRegistrationField,
			[PartyFromField.name]: PartyFromField,
			[PartyToField.name]: PartyToField,
			[RequirementsField.name]: RequirementsField,
		},
		text: 'Instrument no. {{ requisitions.id.fields.instrumentNumber }} is a/an {{ requisitions.id.fields.encumbranceType }} registered on {{ requisitions.id.fields.registrationDate }} from {{ requisitions.id.fields.partyFrom }} in favour of {{ requisitions.id.fields.partyTo }}.',
		requisitionText:
			'REQUIRED: On or before closing, production and registration of a good and valid Release of this Lien.',
		source: '',
		isOnTitle: true,
	},
	{
		id: RequisitionPrecedentIds.CAUTION_CHARGE,
		closerDefault: true,
		version: 1,
		name: 'Caution (charge)',
		fields: {
			[InstrumentNumberField.name]: InstrumentNumberField,
			[EncumbranceTypeField.name]: EncumbranceTypeField,
			[DateOfRegistrationField.name]: DateOfRegistrationField,
			[PartyFromField.name]: PartyFromField,
			[PartyToField.name]: PartyToField,
		},
		text: 'Instrument no. {{ requisitions.id.fields.instrumentNumber }} is a/an {{ requisitions.id.fields.encumbranceType }} registered on {{ requisitions.id.fields.registrationDate }} from {{ requisitions.id.fields.partyFrom }} in favour of {{ requisitions.id.fields.partyTo }}.',
		requisitionText:
			'REQUIRED: On or before closing, production and registration of a withdrawal of said Caution.',
		source: '',
		isOnTitle: true,
	},
	{
		id: RequisitionPrecedentIds.ASSIGNMENT_TITLE,
		closerDefault: true,
		version: 1,
		name: 'Assignment title',
		fields: {
			[InstrumentNumberField.name]: InstrumentNumberField,
			[EncumbranceTypeField.name]: EncumbranceTypeField,
			[DateOfRegistrationField.name]: DateOfRegistrationField,
			[PartyFromField.name]: PartyFromField,
			[PartyToField.name]: PartyToField,
		},
		text: 'Instrument no. {{ requisitions.id.fields.instrumentNumber }} is a/an {{ requisitions.id.fields.encumbranceType }} registered on {{ requisitions.id.fields.registrationDate }} from {{ requisitions.id.fields.partyFrom }} in favour of {{ requisitions.id.fields.partyTo }}.',
		requisitionText:
			'REQUIRED: On or before closing, deletion of this Assignment from title to the subject property.',
		source: '',
		isOnTitle: true,
	},
	{
		id: RequisitionPrecedentIds.ASSIGNMENT_GENERAL,
		closerDefault: true,
		version: 1,
		name: 'Assignment general',
		fields: {
			[InstrumentNumberField.name]: InstrumentNumberField,
			[EncumbranceTypeField.name]: EncumbranceTypeField,
			[DateOfRegistrationField.name]: DateOfRegistrationField,
			[PartyFromField.name]: PartyFromField,
			[PartyToField.name]: PartyToField,
		},
		text: 'Instrument no. {{ requisitions.id.fields.instrumentNumber }} is a/an {{ requisitions.id.fields.encumbranceType }} registered on {{ requisitions.id.fields.registrationDate }} from {{ requisitions.id.fields.partyFrom }} in favour of {{ requisitions.id.fields.partyTo }}.',
		requisitionText:
			'REQUIRED: On or before closing, deletion of this Assignment from title to the subject property.',
		source: '',
		isOnTitle: true,
	},
	{
		id: RequisitionPrecedentIds.CAUTION_OF_AGREEMENT_OF_PURCHASE_AND_SALE,
		closerDefault: true,
		version: 1,
		name: 'Caution of agreement of purchase and sale',
		fields: {
			[InstrumentNumberField.name]: InstrumentNumberField,
			[EncumbranceTypeField.name]: EncumbranceTypeField,
			[DateOfRegistrationField.name]: DateOfRegistrationField,
			[PartyFromField.name]: PartyFromField,
			[PartyToField.name]: PartyToField,
		},
		text: 'Instrument no. {{ requisitions.id.fields.instrumentNumber }} is a/an {{ requisitions.id.fields.encumbranceType }} registered on {{ requisitions.id.fields.registrationDate }} from {{ requisitions.id.fields.partyFrom }} in favour of {{ requisitions.id.fields.partyTo }}.',
		requisitionText:
			'REQUIRED: On or before closing, production and registration of a withdrawal of said Caution.',
		source: '',
		isOnTitle: true,
	},
	{
		id: RequisitionPrecedentIds.CERTIFICATE_OF_TAX,
		closerDefault: true,
		version: 1,
		name: 'Certificate of tax',
		fields: {
			[InstrumentNumberField.name]: InstrumentNumberField,
			[EncumbranceTypeField.name]: EncumbranceTypeField,
			[DateOfRegistrationField.name]: DateOfRegistrationField,
			[PartyFromField.name]: PartyFromField,
			[PartyToField.name]: PartyToField,
		},
		text: 'Instrument no. {{ requisitions.id.fields.instrumentNumber }} is a/an {{ requisitions.id.fields.encumbranceType }} registered on {{ requisitions.id.fields.registrationDate }} from {{ requisitions.id.fields.partyFrom }} in favour of {{ requisitions.id.fields.partyTo }}.',
		requisitionText:
			'REQUIRED: Production and registration of a Tax Arrears Cancellation Certificate and, on or before closing, deletion of this Certificate and all associated documents from title.',
		source: '',
		isOnTitle: true,
	},
	{
		id: RequisitionPrecedentIds.EASEMENT,
		closerDefault: true,
		version: 1,
		name: 'Easement',
		fields: {
			[InstrumentNumberField.name]: InstrumentNumberField,
			[EncumbranceTypeField.name]: EncumbranceTypeField,
			[DateOfRegistrationField.name]: DateOfRegistrationField,
			[PartyFromField.name]: PartyFromField,
			[PartyToField.name]: PartyToField,
			[AreaAffectedByTheEasementField.name]: AreaAffectedByTheEasementField,
		},
		text: 'Instrument no. {{ requisitions.id.fields.instrumentNumber }} is an Easement registered on {{ requisitions.id.fields.registrationDate }} by {{ requisitions.id.fields.partyFrom }} which affects {{ requisitions.id.fields.areaAffectedByEasement }} of the subject property.',
		requisitionText:
			'REQUIRED: On or before closing, production and delivery of evidence no buildings or structures have been erected over the {{ requisitions.id.fields.areaAffectedByEasement }} of the subject property by way of statutory declaration.',
		source: '',
		isOnTitle: true,
	},
	{
		id: RequisitionPrecedentIds.GENERIC_OFF_TITLE,
		closerDefault: true,
		version: 1,
		name: 'Generic off title',
		fields: {
			[PreambleField.name]: PreambleField,
			[RequirementsField.name]: RequirementsField,
		},
		text: '{{ requisitions.id.fields.preamble }}.',
		requisitionText: 'REQUIRED: {{ requisitions.id.fields.requirements }}',
		source: '',
		isOnTitle: false,
	},
	{
		id: RequisitionPrecedentIds.AGREEMENT_OF_PURCHASE_AND_SALE,
		closerDefault: true,
		version: 1,
		name: 'Agreement of Purchase and Sale',
		fields: {
			[InstrumentNumberField.name]: InstrumentNumberField,
			[EncumbranceTypeField.name]: EncumbranceTypeField,
			[DateOfRegistrationField.name]: DateOfRegistrationField,
			[PartyFromField.name]: PartyFromField,
			[PartyToField.name]: PartyToField,
		},
		text: 'Instrument no. {{ requisitions.id.fields.instrumentNumber }} is a/an {{ requisitions.id.fields.encumbranceType }} registered on {{ requisitions.id.fields.registrationDate }} from {{ requisitions.id.fields.partyFrom }} in favour of {{ requisitions.id.fields.partyTo }}.',
		requisitionText:
			'REQUIRED: On or before closing, deletion of said Agreement from title to the subject property.',
		source: '',
		isOnTitle: true,
	},
	{
		id: RequisitionPrecedentIds.AGREEMENT_RE_RIGHT_OF_WAY,
		closerDefault: true,
		version: 1,
		name: 'Agreement re Right of Way',
		fields: {
			[InstrumentNumberField.name]: InstrumentNumberField,
			[EncumbranceTypeField.name]: EncumbranceTypeField,
			[DateOfRegistrationField.name]: DateOfRegistrationField,
			[PartyFromField.name]: PartyFromField,
			[PartyToField.name]: PartyToField,
		},
		text: 'Instrument no. is a/an {{ requisitions.id.fields.encumbranceType }} registered on {{ requisitions.id.fields.registrationDate }} from {{ requisitions.id.fields.partyFrom }} in favour of {{ requisitions.id.fields.partyTo }}.',
		requisitionText:
			'REQUIRED: On or before closing, production and registration of a Release of the said Agreement re Right of Way from the person entitled to use thereof and registration of the necessary application to delete the said right of way from title to the subject property.',
		source: '',
		isOnTitle: true,
	},
	{
		id: RequisitionPrecedentIds.APPLICATION_FOR_INHIBITING_ORDER,
		closerDefault: true,
		version: 1,
		name: 'Application for Inhibiting Order',
		fields: {
			[InstrumentNumberField.name]: InstrumentNumberField,
			[EncumbranceTypeField.name]: EncumbranceTypeField,
			[DateOfRegistrationField.name]: DateOfRegistrationField,
			[PartyFromField.name]: PartyFromField,
			[PartyToField.name]: PartyToField,
		},
		text: 'Instrument no. {{ requisitions.id.fields.instrumentNumber }} is a/an {{ requisitions.id.fields.encumbranceType }} registered on {{ requisitions.id.fields.registrationDate }} from {{ requisitions.id.fields.partyFrom }} in favour of {{ requisitions.id.fields.partyTo }}.',
		requisitionText:
			'REQUIRED: On or before closing, deletion of this Inhibiting Order from title to the subject property.',
		source: '',
		isOnTitle: true,
	},
	{
		id: RequisitionPrecedentIds.APPLICATION_TO_ANNEX_RESTRICTIVE_COV,
		closerDefault: true,
		version: 1,
		name: 'Application to Annex Restrictive Cov s.118',
		fields: {
			[InstrumentNumberField.name]: InstrumentNumberField,
			[EncumbranceTypeField.name]: EncumbranceTypeField,
			[DateOfRegistrationField.name]: DateOfRegistrationField,
			[PartyFromField.name]: PartyFromField,
			[PartyToField.name]: PartyToField,
		},
		text: 'Instrument no. {{ requisitions.id.fields.instrumentNumber }} is a/an {{ requisitions.id.fields.encumbranceType }} registered on {{ requisitions.id.fields.registrationDate }} from {{ requisitions.id.fields.partyFrom }} in favour of {{ requisitions.id.fields.partyTo }}.',
		requisitionText:
			'REQUIRED: On or before closing: \n a) production and delivery of evidence that the said Covenants have been complied with in full to date, and \n b) Approval of Plans, and \n c) deletion of said Covenants from title to the subject property.',
		source: '',
		isOnTitle: true,
	},
	{
		id: RequisitionPrecedentIds.CAUTION_CHARGE_BANKRUPTCY_AND_INSOLVENCY,
		closerDefault: true,
		version: 1,
		name: 'Caution - Charge (Bankruptcy & Insolvency Act)',
		fields: {
			[InstrumentNumberField.name]: InstrumentNumberField,
			[EncumbranceTypeField.name]: EncumbranceTypeField,
			[DateOfRegistrationField.name]: DateOfRegistrationField,
			[PartyFromField.name]: PartyFromField,
			[PartyToField.name]: PartyToField,
		},
		text: 'Instrument no. {{ requisitions.id.fields.instrumentNumber }} is a/an {{ requisitions.id.fields.encumbranceType }} registered on {{ requisitions.id.fields.registrationDate }} from {{ requisitions.id.fields.partyFrom }} in favour of {{ requisitions.id.fields.partyTo }}.',
		requisitionText:
			'REQUIRED: On or before closing, production and registration of a withdrawal of said Caution.',
		source: '',
		isOnTitle: true,
	},
	{
		id: RequisitionPrecedentIds.CAUTION_LAND,
		closerDefault: true,
		version: 1,
		name: 'Caution - Land',
		fields: {
			[InstrumentNumberField.name]: InstrumentNumberField,
			[EncumbranceTypeField.name]: EncumbranceTypeField,
			[DateOfRegistrationField.name]: DateOfRegistrationField,
			[PartyFromField.name]: PartyFromField,
			[PartyToField.name]: PartyToField,
		},
		text: 'Instrument no. {{ requisitions.id.fields.instrumentNumber }} is a/an {{ requisitions.id.fields.encumbranceType }} registered on {{ requisitions.id.fields.registrationDate }} from {{ requisitions.id.fields.partyFrom }} in favour of {{ requisitions.id.fields.partyTo }}.',
		requisitionText:
			'REQUIRED: On or before closing, production and registration of a withdrawal of said Caution.',
		source: '',
		isOnTitle: true,
	},
	{
		id: RequisitionPrecedentIds.CAUTION_LAND_BANKRUPTCY_AND_INSOLVENCY,
		closerDefault: true,
		version: 1,
		name: 'Caution - Land (Bankruptcy and Insolvency Act)',
		fields: {
			[InstrumentNumberField.name]: InstrumentNumberField,
			[EncumbranceTypeField.name]: EncumbranceTypeField,
			[DateOfRegistrationField.name]: DateOfRegistrationField,
			[PartyFromField.name]: PartyFromField,
			[PartyToField.name]: PartyToField,
		},
		text: 'Instrument no. {{ requisitions.id.fields.instrumentNumber }} is a/an {{ requisitions.id.fields.encumbranceType }} registered on {{ requisitions.id.fields.registrationDate }} from {{ requisitions.id.fields.partyFrom }} in favour of {{ requisitions.id.fields.partyTo }}.',
		requisitionText:
			'REQUIRED: On or before closing, production and registration of a withdrawal of said Caution.',
		source: '',
		isOnTitle: true,
	},
	{
		id: RequisitionPrecedentIds.CAUTION_LAND_ESTATES_ADMINISTRATION_ACT,
		closerDefault: true,
		version: 1,
		name: 'Caution - Land (Estates Administration Act)',
		fields: {
			[InstrumentNumberField.name]: InstrumentNumberField,
			[EncumbranceTypeField.name]: EncumbranceTypeField,
			[DateOfRegistrationField.name]: DateOfRegistrationField,
			[PartyFromField.name]: PartyFromField,
			[PartyToField.name]: PartyToField,
		},
		text: 'Instrument no. {{ requisitions.id.fields.instrumentNumber }} is a/an {{ requisitions.id.fields.encumbranceType }} registered on {{ requisitions.id.fields.registrationDate }} from {{ requisitions.id.fields.partyFrom }} in favour of {{ requisitions.id.fields.partyTo }}.',
		requisitionText:
			'REQUIRED: On or before closing, production and registration of a withdrawal of said Caution.',
		source: '',
		isOnTitle: true,
	},
	{
		id: RequisitionPrecedentIds.CERTIFICATE_HOME_RENEWAL_PROGRAMME_LOAN,
		closerDefault: true,
		version: 1,
		name: 'Certificate Home Renewal Programme Loan',
		fields: {
			[InstrumentNumberField.name]: InstrumentNumberField,
			[EncumbranceTypeField.name]: EncumbranceTypeField,
			[DateOfRegistrationField.name]: DateOfRegistrationField,
			[PartyFromField.name]: PartyFromField,
			[PartyToField.name]: PartyToField,
			[InstrumentNumberField.name]: InstrumentNumberField,
		},
		text: 'Instrument no. {{ requisitions.id.fields.instrumentNumber }} is a/an {{ requisitions.id.fields.encumbranceType }} registered on {{ requisitions.id.fields.registrationDate }} from {{ requisitions.id.fields.partyFrom }} in favour of {{ requisitions.id.fields.partyTo }} in the amount of {{ requisitions.id.fields.instrumentAmount.formatted }}.',
		requisitionText:
			'REQUIRED: On or before closing, production and registration of a good and valid Discharge of this Certificate.',
		source: '',
		isOnTitle: true,
	},
	{
		id: RequisitionPrecedentIds.CERTIFICATE_HOUSING_DEVELOPMENT_ACT,
		closerDefault: true,
		version: 1,
		name: 'Certificate Housing Development Act',
		fields: {
			[InstrumentNumberField.name]: InstrumentNumberField,
			[EncumbranceTypeField.name]: EncumbranceTypeField,
			[DateOfRegistrationField.name]: DateOfRegistrationField,
			[PartyFromField.name]: PartyFromField,
			[PartyToField.name]: PartyToField,
			[InstrumentNumberField.name]: InstrumentNumberField,
			[InstrumentAmountField.name]: InstrumentAmountField,
		},
		text: 'Instrument no. {{ requisitions.id.fields.instrumentNumber }} is a/an {{ requisitions.id.fields.encumbranceType }} registered on {{ requisitions.id.fields.registrationDate }} from {{ requisitions.id.fields.partyFrom }} in favour of {{ requisitions.id.fields.partyTo }} in the amount of {{ requisitions.id.fields.instrumentAmount.formatted }}.',
		requisitionText:
			'REQUIRED: On or before closing, production and registration of a good and valid Discharge of this Certificate.',
		source: '',
		isOnTitle: true,
	},
	{
		id: RequisitionPrecedentIds.CERTIFICATE_OF_ACTION,
		closerDefault: true,
		version: 1,
		name: 'Certificate of Action',
		fields: {
			[InstrumentNumberField.name]: InstrumentNumberField,
			[EncumbranceTypeField.name]: EncumbranceTypeField,
			[DateOfRegistrationField.name]: DateOfRegistrationField,
			[PartyFromField.name]: PartyFromField,
			[PartyToField.name]: PartyToField,
		},
		text: 'Instrument no. {{ requisitions.id.fields.instrumentNumber }} is a/an {{ requisitions.id.fields.encumbranceType }} registered on {{ requisitions.id.fields.registrationDate }} from {{ requisitions.id.fields.partyFrom }} in favour of {{ requisitions.id.fields.partyTo }}.',
		requisitionText:
			'REQUIRED: On or before closing, production and registration of a good and valid Release of this Certificate of Action or, in the alternative, production and registration of an Order vacating this Certificate of Action.',
		source: '',
		isOnTitle: true,
	},
	{
		id: RequisitionPrecedentIds.CERTIFICATE_OF_LIEN_HOUSING_DEVELOPMENT_ACT,
		closerDefault: true,
		version: 1,
		name: 'Certificate of Lien - Housing Development Act',
		fields: {
			[InstrumentNumberField.name]: InstrumentNumberField,
			[EncumbranceTypeField.name]: EncumbranceTypeField,
			[DateOfRegistrationField.name]: DateOfRegistrationField,
			[PartyFromField.name]: PartyFromField,
			[PartyToField.name]: PartyToField,
		},
		text: 'Instrument no. {{ requisitions.id.fields.instrumentNumber }} is a/an {{ requisitions.id.fields.encumbranceType }} registered on {{ requisitions.id.fields.registrationDate }} from {{ requisitions.id.fields.partyFrom }} in favour of {{ requisitions.id.fields.partyTo }}.',
		requisitionText:
			'REQUIRED: On or before closing, production and registration of a good and valid Release of this Certificate.',
		source: '',
		isOnTitle: true,
	},
	{
		id: RequisitionPrecedentIds.CERTIFICATE_OF_PENDING_LITIGATION,
		closerDefault: true,
		version: 1,
		name: 'Certificate of Pending Litigation',
		fields: {
			[InstrumentNumberField.name]: InstrumentNumberField,
			[EncumbranceTypeField.name]: EncumbranceTypeField,
			[DateOfRegistrationField.name]: DateOfRegistrationField,
			[PartyFromField.name]: PartyFromField,
			[PartyToField.name]: PartyToField,
		},
		text: 'Instrument no. {{ requisitions.id.fields.instrumentNumber }} is a/an {{ requisitions.id.fields.encumbranceType }} registered on {{ requisitions.id.fields.registrationDate }} from {{ requisitions.id.fields.partyFrom }} in favour of {{ requisitions.id.fields.partyTo }}.',
		requisitionText:
			'REQUIRED: On or before closing, production and registration of a good and valid Discharge of this Certificate.',
		source: '',
		isOnTitle: true,
	},
	{
		id: RequisitionPrecedentIds.CHARGE_ASSUMED_AMENDED_TERMS,
		closerDefault: true,
		version: 1,
		name: 'Charge (Assumed, amended terms)',
		fields: {
			[InstrumentNumberField.name]: InstrumentNumberField,
			[EncumbranceTypeField.name]: EncumbranceTypeField,
			[DateOfRegistrationField.name]: DateOfRegistrationField,
			[PartyFromField.name]: PartyFromField,
			[PartyToField.name]: PartyToField,
			[InstrumentAmountField.name]: InstrumentAmountField,
		},
		text: 'Instrument no. is a/an {{ requisitions.id.fields.encumbranceType }} registered on {{ requisitions.id.fields.registrationDate }} from {{ requisitions.id.fields.partyFrom }} in favour of {{ requisitions.id.fields.partyTo }} securing the principal sum of {{ requisitions.id.fields.instrumentAmount.formatted }}.',
		requisitionText:
			'REQUIRED: On or before closing, production and registration of a good and valid discharge of this Mortgage.  If this is the mortgage which our client is to assume, then we will require a current mortgage statement for assumption purposes conforming with the Agreement of Purchase and Sale and your Statement of Adjustments and showing the mortgage to be in current standing.  In addition, since the terms of the mortgage as registered do not correspond with those in the Agreement of Purchase and Sale, we will require production and delivery of a valid agreement amending the mortgage setting out terms conforming with the Agreement of Purchase and Sale.',
		source: '',
		isOnTitle: true,
	},
	{
		id: RequisitionPrecedentIds.CHARGE_ASSUMED_EXISTING_TERMS,
		closerDefault: true,
		version: 1,
		name: 'Charge (Assumed, existing terms)',
		fields: {
			[InstrumentNumberField.name]: InstrumentNumberField,
			[EncumbranceTypeField.name]: EncumbranceTypeField,
			[DateOfRegistrationField.name]: DateOfRegistrationField,
			[PartyFromField.name]: PartyFromField,
			[PartyToField.name]: PartyToField,
			[InstrumentNumberField.name]: InstrumentNumberField,
			[InstrumentAmountField.name]: InstrumentAmountField,
		},
		text: 'Instrument no. {{ requisitions.id.fields.instrumentNumber }} is a/an {{ requisitions.id.fields.encumbranceType }} registered on {{ requisitions.id.fields.registrationDate }} from {{ requisitions.id.fields.partyFrom }} in favour of {{ requisitions.id.fields.partyTo }} securing the principal sum of {{ requisitions.id.fields.instrumentAmount.formatted }}.',
		requisitionText:
			'REQUIRED: On or before closing, production and registration of a good and valid discharge of this Mortgage.  If this is the mortgage which our client is to assume, then we will require a current mortgage statement for assumption purposes conforming with the Agreement of Purchase and Sale and your Statement of Adjustments and showing the mortgage to be in current standing.',
		source: '',
		isOnTitle: true,
	},
	{
		id: RequisitionPrecedentIds.CHARGE_BY_PARTNERSHIP,
		closerDefault: true,
		version: 2,
		name: 'Charge by Partnership',
		fields: {
			[InstrumentNumberField.name]: InstrumentNumberField,
			[EncumbranceTypeField.name]: EncumbranceTypeField,
			[DateOfRegistrationField.name]: DateOfRegistrationField,
			[PartyFromField.name]: PartyFromField,
			[PartyToField.name]: PartyToField,
			[InstrumentNumberField.name]: InstrumentNumberField,
		},
		text: 'Instrument no. {{ requisitions.id.fields.instrumentNumber }} is a/an {{ requisitions.id.fields.encumbranceType }} registered on {{ requisitions.id.fields.registrationDate }} from {{ requisitions.id.fields.partyFrom }} in favour of {{ requisitions.id.fields.partyTo }} securing principal sum of {{ requisitions.id.fields.instrumentAmount.formatted }}.',
		requisitionText:
			'REQUIRED: On or before closing, production and registration of a good and valid discharge of this Mortgage. \n If you do not have the discharge of Mortgage on the closing date we will require a copy of the discharge statement from {{ requisitions.id.fields.partyTo }} showing the balance outstanding as of the closing date, a direction to make funds payable to {{ requisitions.id.fields.partyTo }}, and your firm undertaking to obtain and register a good and valid discharge of said Mortgage.',
		source: '',
		isOnTitle: true,
	},
	{
		id: RequisitionPrecedentIds.CHARGE_BY_RELIGIOUS_ORGANIZATION,
		closerDefault: true,
		version: 2,
		name: 'Charge by Religious Organization',
		fields: {
			[InstrumentNumberField.name]: InstrumentNumberField,
			[EncumbranceTypeField.name]: EncumbranceTypeField,
			[DateOfRegistrationField.name]: DateOfRegistrationField,
			[PartyFromField.name]: PartyFromField,
			[PartyToField.name]: PartyToField,
			[InstrumentAmountField.name]: InstrumentAmountField,
		},
		text: 'Instrument no. {{ requisitions.id.fields.instrumentNumber }} is a/an {{ requisitions.id.fields.encumbranceType }} registered on {{ requisitions.id.fields.registrationDate }} from {{ requisitions.id.fields.partyFrom }} in favour of {{ requisitions.id.fields.partyTo }} securing principal sum of {{ requisitions.id.fields.instrumentAmount.formatted }}.',
		requisitionText:
			'REQUIRED: On or before closing, production and registration of a good and valid discharge of this Mortgage. \n If you do not have the discharge of Mortgage on the closing date we will require a copy of the discharge statement from {{ requisitions.id.fields.partyTo }} showing the balance outstanding as of the closing date, a direction to make funds payable to {{ requisitions.id.fields.partyTo }}, and your firm undertaking to obtain and register a good and valid discharge of said Mortgage.',
		source: '',
		isOnTitle: true,
	},
	{
		id: RequisitionPrecedentIds.CHARGE_WITH_POSTPONEMENT,
		closerDefault: true,
		version: 2,
		name: 'Charge with Postponement',
		fields: {
			[InstrumentNumberField.name]: InstrumentNumberField,
			[EncumbranceTypeField.name]: EncumbranceTypeField,
			[DateOfRegistrationField.name]: DateOfRegistrationField,
			[PartyFromField.name]: PartyFromField,
			[PartyToField.name]: PartyToField,
			[InstrumentNumberField.name]: InstrumentNumberField,
			[PostPonementInstrumentNumberField.name]:
				PostPonementInstrumentNumberField,
			[RegistrationDateForPostponementField.name]:
				RegistrationDateForPostponementField,
			[NameOfOtherMortgageField.name]: NameOfOtherMortgageField,
			[InstrumentNumberOfMortgagePostponedField.name]:
				InstrumentNumberOfMortgagePostponedField,
			[InstrumentNumberOfMortgageBenefitingFromPostponementField.name]:
				InstrumentNumberOfMortgageBenefitingFromPostponementField,
			[InstrumentAmountField.name]: InstrumentAmountField,
		},
		text: 'Instrument no. {{ requisitions.id.fields.instrumentNumber }} is a/an {{ requisitions.id.fields.encumbranceType }} registered on {{ requisitions.id.fields.registrationDate }} from {{ requisitions.id.fields.partyFrom }} in favour of {{ requisitions.id.fields.partyTo }} securing principal sum of {{ requisitions.id.fields.instrumentAmount.formatted }}.',
		requisitionText:
			'REQUIRED: On or before closing, production and registration of a good and valid discharge of this Mortgage and deletion of any associated Postponement of Interest. \nIn addition, Instrument No. {{ requisitions.id.fields.postponementInstrumentNumber }} is a Postponement of Interest registered {{ requisitions.id.fields.postponementRegistrationDate }} between {{ requisitions.id.fields.partyTo }} and {{ requisitions.id.fields.otherMortgageName }} postponing Instrument No. {{ requisitions.id.fields.postponedMortgageInstrumentNumber }} to Instrument No. {{ requisitions.id.fields.mortgageBenefitingFromPostponementInstrumentNumber }}. \nIf you do not have the discharge of Mortgage on the closing date we will require a copy of the discharge statement from {{ requisitions.id.fields.partyTo }} showing the balance outstanding as of the closing date, a direction to make funds payable to {{ requisitions.id.fields.partyTo }}, and your firm undertaking to obtain and register a good and valid discharge of said Mortgage.',
		source: '',
		isOnTitle: true,
	},
	{
		id: RequisitionPrecedentIds.CHARGE_WITH_TRANSFER_OF_CHARGE,
		closerDefault: true,
		version: 2,
		name: 'Charge with Transfer of Charge',
		fields: {
			[InstrumentNumberField.name]: InstrumentNumberField,
			[EncumbranceTypeField.name]: EncumbranceTypeField,
			[DateOfRegistrationField.name]: DateOfRegistrationField,
			[PartyFromField.name]: PartyFromField,
			[PartyToField.name]: PartyToField,
			[InstrumentNumberOfTransferOfChargeField.name]:
				InstrumentNumberOfTransferOfChargeField,
			[RegistrationDateOfTransferOfChargeField.name]:
				RegistrationDateOfTransferOfChargeField,
			[TransfereeInTransferOfChargeField.name]:
				TransfereeInTransferOfChargeField,
			[InstrumentAmountField.name]: InstrumentAmountField,
		},
		text: 'Instrument no. {{ requisitions.id.fields.instrumentNumber }} is a {{ requisitions.id.fields.encumbranceType }} registered on {{ requisitions.id.fields.registrationDate }} from {{ requisitions.id.fields.partyFrom }} in favour of {{ requisitions.id.fields.partyTo }} securing principal sum of {{ requisitions.id.fields.instrumentAmount.formatted }}. This {{ requisitions.id.fields.encumbranceType }} was subsequently transferred by Transfer of Charge registered as Instrument No. {{ requisitions.id.fields.transferChargeInstrumentNumber }} registered on {{ requisitions.id.fields.transferChargeRegistrationDate }} from {{ requisitions.id.fields.partyTo }} in favour of {{ requisitions.id.fields.chargeTransferTransferee }}.',
		requisitionText:
			'REQUIRED: On or before closing, production and registration of a good and valid discharge of this Mortgage and deletion from title of the associated Transfer of Charge. \nIf you do not have the discharge of Mortgage on the closing date we will require a copy of the discharge statement from {{ requisitions.id.fields.partyTo }} showing the balance outstanding as of the closing date, a direction to make funds payable to {{ requisitions.id.fields.partyTo }}, and your firm undertaking to obtain and register a good and valid discharge of said Mortgage.',
		source: '',
		isOnTitle: true,
	},
	{
		id: RequisitionPrecedentIds.CONDOMINIUM_LIEN,
		closerDefault: true,
		version: 1,
		name: 'Condominium Lien',
		fields: {
			[InstrumentNumberField.name]: InstrumentNumberField,
			[EncumbranceTypeField.name]: EncumbranceTypeField,
			[DateOfRegistrationField.name]: DateOfRegistrationField,
			[PartyFromField.name]: PartyFromField,
			[PartyToField.name]: PartyToField,
			[InstrumentAmountField.name]: InstrumentAmountField,
		},
		text: 'Instrument no. {{ requisitions.id.fields.instrumentNumber }} is a/an {{ requisitions.id.fields.encumbranceType }} registered on {{ requisitions.id.fields.registrationDate }} from {{ requisitions.id.fields.partyFrom }} in favour of {{ requisitions.id.fields.partyTo }} in the amount of {{ requisitions.id.fields.instrumentAmount.formatted }}.',
		requisitionText:
			'REQUIRED: On or before closing, production and registration of a good and valid Release of this Lien.',
		source: '',
		isOnTitle: true,
	},
	{
		id: RequisitionPrecedentIds.CONSTRUCTION_LIEN,
		closerDefault: true,
		version: 1,
		name: 'Construction Lien',
		fields: {
			[InstrumentNumberField.name]: InstrumentNumberField,
			[EncumbranceTypeField.name]: EncumbranceTypeField,
			[DateOfRegistrationField.name]: DateOfRegistrationField,
			[PartyFromField.name]: PartyFromField,
			[PartyToField.name]: PartyToField,
			[InstrumentAmountField.name]: InstrumentAmountField,
		},
		text: 'Instrument no. {{ requisitions.id.fields.instrumentNumber }} is a/an {{ requisitions.id.fields.encumbranceType }} registered on {{ requisitions.id.fields.registrationDate }} from {{ requisitions.id.fields.partyFrom }} in favour of {{ requisitions.id.fields.partyTo }} in the amount of {{ requisitions.id.fields.instrumentAmount.formatted }}.',
		requisitionText:
			'REQUIRED: On or before closing, production and registration of a good and valid Release of this lien and any associated Certificate of Action or, in the alternative, production and registration of an Order discharging the Lien and vacating any associated Certificate of Action.',
		source: '',
		isOnTitle: true,
	},
	{
		id: RequisitionPrecedentIds.DEBENTURE,
		closerDefault: true,
		version: 1,
		name: 'Debenture',
		fields: {
			[InstrumentNumberField.name]: InstrumentNumberField,
			[EncumbranceTypeField.name]: EncumbranceTypeField,
			[DateOfRegistrationField.name]: DateOfRegistrationField,
			[PartyFromField.name]: PartyFromField,
			[PartyToField.name]: PartyToField,
			[InstrumentAmountField.name]: InstrumentAmountField,
		},
		text: 'Instrument no. {{ requisitions.id.fields.instrumentNumber }} is a/an {{ requisitions.id.fields.encumbranceType }} registered on {{ requisitions.id.fields.registrationDate }} from {{ requisitions.id.fields.partyFrom }} in favour of {{ requisitions.id.fields.partyTo }} securing principal sum of {{ requisitions.id.fields.instrumentAmount.formatted }}.',
		requisitionText:
			'REQUIRED: On or before closing, production and registration of a good and valid discharge of this Debenture.',
		source: '',
		isOnTitle: true,
	},
	{
		id: RequisitionPrecedentIds.DESIGNATION_OF_MATRIMONIAL_HOME,
		closerDefault: true,
		version: 1,
		name: 'Designation of Matrimonial Home',
		fields: {
			[InstrumentNumberField.name]: InstrumentNumberField,
			[EncumbranceTypeField.name]: EncumbranceTypeField,
			[DateOfRegistrationField.name]: DateOfRegistrationField,
			[PartyFromField.name]: PartyFromField,
			[PartyToField.name]: PartyToField,
		},
		text: 'Instrument no. {{ requisitions.id.fields.instrumentNumber }} is a/an {{ requisitions.id.fields.encumbranceType }} registered on {{ requisitions.id.fields.registrationDate }} from {{ requisitions.id.fields.partyFrom }} in favour of {{ requisitions.id.fields.partyTo }}.',
		requisitionText:
			'REQUIRED: On or before closing, production and registration of a good and valid Cancellation of Designation of Matrimonial Home.',
		source: '',
		isOnTitle: true,
	},
	{
		id: RequisitionPrecedentIds.EXECUTIONS_REGISTRY,
		closerDefault: true,
		version: 1,
		name: 'Executions (Registry)',
		fields: {
			[NameUsedForSearchField.name]: NameUsedForSearchField,
			[NumberOfExecutionsField.name]: NumberOfExecutionsField,
			[NameOfOwnerField.name]: NameOfOwnerField,
			[RegionField.name]: RegionField,
		},
		text: 'Our search of executions against the name {{ requisitions.id.fields.searchTextName }} disclosed the existence of the {{ requisitions.id.fields.executionsNumber }} execution(s) against such person (or similar name), particulars of which have been enclosed herewith for your convenience.',
		requisitionText:
			'REQUIRED: On or before closing, satisfaction of the above execution(s) together with costs and the withdrawal thereof from the files of the Sheriff of {{ requisitions.id.fields.region }} or, in the alternative, production and registration, by way of a Deposit on title, of evidence satisfactory to the writer that, for the aforesaid execution(s), the debtor named therein is not one and the same person as {{ requisitions.id.fields.ownerName }}, the registered owner of the property.  In the event of an execution with a levy of greater than or equal to $50,000.00, it will be necessary to register a declaration of the solicitor or a letter from the execution creditor or his solicitor verifying that the execution debtor is not one and the same person as {{ requisitions.id.fields.ownerName }}, the registered owner of the property, in which case drafts thereof are to be provided to our office prior to closing.',
		source: '',
		isOnTitle: false,
	},
	{
		id: RequisitionPrecedentIds.LAND_REGISTRARS_CAUTION,
		closerDefault: true,
		version: 1,
		name: "Land Registrar's Caution",
		fields: {
			[InstrumentNumberField.name]: InstrumentNumberField,
			[EncumbranceTypeField.name]: EncumbranceTypeField,
			[DateOfRegistrationField.name]: DateOfRegistrationField,
			[PartyFromField.name]: PartyFromField,
			[PartyToField.name]: PartyToField,
		},
		text: 'Instrument no. {{ requisitions.id.fields.instrumentNumber }} is a/an {{ requisitions.id.fields.encumbranceType }} registered on {{ requisitions.id.fields.registrationDate }}.',
		requisitionText:
			'REQUIRED: On or before closing, production and registration of a withdrawal of said Caution.',
		source: '',
		isOnTitle: true,
	},
	{
		id: RequisitionPrecedentIds.LEASE,
		closerDefault: true,
		version: 1,
		name: 'Lease',
		fields: {
			[InstrumentNumberField.name]: InstrumentNumberField,
			[EncumbranceTypeField.name]: EncumbranceTypeField,
			[DateOfRegistrationField.name]: DateOfRegistrationField,
			[PartyFromField.name]: PartyFromField,
			[PartyToField.name]: PartyToField,
			[InstrumentAmountField.name]: InstrumentAmountField,
		},
		text: 'Instrument no. {{ requisitions.id.fields.instrumentNumber }} is a/an {{ requisitions.id.fields.encumbranceType }} registered on {{ requisitions.id.fields.registrationDate }} from {{ requisitions.id.fields.partyFrom }} in favour of {{ requisitions.id.fields.partyTo }} securing principal sum of {{ requisitions.id.fields.instrumentAmount.formatted }}.',
		requisitionText:
			'REQUIRED: On or before closing, production and registration of the necessary documentation to remove this Lease, and any associated instruments, from title.',
		source: '',
		isOnTitle: true,
	},
	{
		id: RequisitionPrecedentIds.LIS_PENDENS,
		closerDefault: true,
		version: 1,
		name: 'Lis Pendens',
		fields: {
			[InstrumentNumberField.name]: InstrumentNumberField,
			[EncumbranceTypeField.name]: EncumbranceTypeField,
			[DateOfRegistrationField.name]: DateOfRegistrationField,
			[PartyFromField.name]: PartyFromField,
			[PartyToField.name]: PartyToField,
		},
		text: 'Instrument no. {{ requisitions.id.fields.instrumentNumber }} is a/an {{ requisitions.id.fields.encumbranceType }} registered on {{ requisitions.id.fields.registrationDate }} from {{ requisitions.id.fields.partyFrom }} in favour of {{ requisitions.id.fields.partyTo }}.',
		requisitionText:
			'REQUIRED: On or before closing, production and registration of a good and valid Discharge of this Lis Pendens.',
		source: '',
		isOnTitle: true,
	},
	{
		id: RequisitionPrecedentIds.LODGEMENT_OF_TITLE,
		closerDefault: true,
		version: 1,
		name: 'Lodgement of Title',
		fields: {
			[InstrumentNumberField.name]: InstrumentNumberField,
			[EncumbranceTypeField.name]: EncumbranceTypeField,
			[DateOfRegistrationField.name]: DateOfRegistrationField,
			[PartyFromField.name]: PartyFromField,
			[PartyToField.name]: PartyToField,
			[InstrumentAmountField.name]: InstrumentAmountField,
		},
		text: 'Instrument no. {{ requisitions.id.fields.instrumentNumber }} is a/an {{ requisitions.id.fields.encumbranceType }} registered on {{ requisitions.id.fields.registrationDate }} from {{ requisitions.id.fields.partyFrom }} in favour of {{ requisitions.id.fields.partyTo }} securing principal sum of {{ requisitions.id.fields.instrumentAmount.formatted }}.',
		requisitionText:
			'REQUIRED: On or before closing, production and registration of a good and valid discharge of this Lodgement of Title.',
		source: '',
		isOnTitle: true,
	},
	{
		id: RequisitionPrecedentIds.NOTICE_OF_AGREEMENT_OF_PURCHASE_AND_SALE,
		closerDefault: true,
		version: 1,
		name: 'Notice of Agreement of Purchase and Sale',
		fields: {
			[InstrumentNumberField.name]: InstrumentNumberField,
			[EncumbranceTypeField.name]: EncumbranceTypeField,
			[DateOfRegistrationField.name]: DateOfRegistrationField,
			[PartyFromField.name]: PartyFromField,
			[PartyToField.name]: PartyToField,
			[InstrumentAmountField.name]: InstrumentAmountField,
		},
		text: 'Instrument no. {{ requisitions.id.fields.instrumentNumber }} is a/an {{ requisitions.id.fields.encumbranceType }} registered on {{ requisitions.id.fields.registrationDate }} from {{ requisitions.id.fields.partyFrom }} in favour of {{ requisitions.id.fields.partyTo }} securing principal sum of {{ requisitions.id.fields.instrumentAmount.formatted }}.',
		requisitionText:
			'REQUIRED: On or before closing, deletion of said Notice from title to the subject property.',
		source: '',
		isOnTitle: true,
	},
	{
		id: RequisitionPrecedentIds.NOTICE_OF_ASSIGNMENT_OF_RENT_GENERAL,
		closerDefault: true,
		version: 1,
		name: 'Notice of Assignment of Rent General',
		fields: {
			[InstrumentNumberField.name]: InstrumentNumberField,
			[EncumbranceTypeField.name]: EncumbranceTypeField,
			[DateOfRegistrationField.name]: DateOfRegistrationField,
			[PartyFromField.name]: PartyFromField,
			[PartyToField.name]: PartyToField,
			[InstrumentAmountField.name]: InstrumentAmountField,
		},
		text: 'Instrument no. {{ requisitions.id.fields.instrumentNumber }} is a/an {{ requisitions.id.fields.encumbranceType }} registered on {{ requisitions.id.fields.registrationDate }} from {{ requisitions.id.fields.partyFrom }} in favour of {{ requisitions.id.fields.partyTo }} securing principal sum of {{ requisitions.id.fields.instrumentAmount.formatted }}.',
		requisitionText:
			'REQUIRED: On or before closing, deletion of this Notice of Assignment of Rents from title to the subject property.',
		source: '',
		isOnTitle: true,
	},
	{
		id: RequisitionPrecedentIds.NOTICE_OF_LEASE,
		closerDefault: true,
		version: 1,
		name: 'Notice of Lease',
		fields: {
			[InstrumentNumberField.name]: InstrumentNumberField,
			[EncumbranceTypeField.name]: EncumbranceTypeField,
			[DateOfRegistrationField.name]: DateOfRegistrationField,
			[PartyFromField.name]: PartyFromField,
			[PartyToField.name]: PartyToField,
			[InstrumentAmountField.name]: InstrumentAmountField,
		},
		text: 'Instrument no. {{ requisitions.id.fields.instrumentNumber }} is a/an {{ requisitions.id.fields.encumbranceType }} registered on {{ requisitions.id.fields.registrationDate }} from {{ requisitions.id.fields.partyFrom }} in favour of {{ requisitions.id.fields.partyTo }} securing principal sum of {{ requisitions.id.fields.instrumentAmount.formatted }}.',
		requisitionText:
			'REQUIRED: On or before closing, production and registration of the necessary documentation to remove this Notice of Lease, and any associated instruments, from title.',
		source: '',
		isOnTitle: true,
	},
	{
		id: RequisitionPrecedentIds.NOTICE_OF_LIEN_MUNICIPAL_SCHOOL_TAX_CREDIT,
		closerDefault: true,
		version: 1,
		name: 'Notice of Lien Municipal & School Tax Credit',
		fields: {
			[InstrumentNumberField.name]: InstrumentNumberField,
			[EncumbranceTypeField.name]: EncumbranceTypeField,
			[DateOfRegistrationField.name]: DateOfRegistrationField,
			[PartyFromField.name]: PartyFromField,
			[PartyToField.name]: PartyToField,
			[InstrumentAmountField.name]: InstrumentAmountField,
		},
		text: 'Instrument no. {{ requisitions.id.fields.instrumentNumber }} is a/an {{ requisitions.id.fields.encumbranceType }} registered on {{ requisitions.id.fields.registrationDate }} from {{ requisitions.id.fields.partyFrom }} in favour of {{ requisitions.id.fields.partyTo }} securing principal sum of {{ requisitions.id.fields.instrumentAmount.formatted }}.',
		requisitionText:
			'REQUIRED: On or before closing, deletion of this Notice of Lien from title to the subject property.',
		source: '',
		isOnTitle: true,
	},
	{
		id: RequisitionPrecedentIds.NOTICE_OF_OIL_AND_GAS_LEASE,
		closerDefault: true,
		version: 1,
		name: 'Notice of Oil & Gas Lease',
		fields: {
			[InstrumentNumberField.name]: InstrumentNumberField,
			[EncumbranceTypeField.name]: EncumbranceTypeField,
			[DateOfRegistrationField.name]: DateOfRegistrationField,
			[PartyFromField.name]: PartyFromField,
			[PartyToField.name]: PartyToField,
			[InstrumentAmountField.name]: InstrumentAmountField,
		},
		text: 'Instrument no. {{ requisitions.id.fields.instrumentNumber }} is a/an {{ requisitions.id.fields.encumbranceType }} registered on {{ requisitions.id.fields.registrationDate }} from {{ requisitions.id.fields.partyFrom }} in favour of {{ requisitions.id.fields.partyTo }} securing principal sum of {{ requisitions.id.fields.instrumentAmount.formatted }}.',
		requisitionText:
			'REQUIRED: On or before closing, deletion of this Notice of Lien from title to the subject property.',
		source: '',
		isOnTitle: true,
	},
	{
		id: RequisitionPrecedentIds.NOTICE_OF_OPTION_TO_LEASE,
		closerDefault: true,
		version: 1,
		name: 'Notice of Option to Lease',
		fields: {
			[InstrumentNumberField.name]: InstrumentNumberField,
			[EncumbranceTypeField.name]: EncumbranceTypeField,
			[DateOfRegistrationField.name]: DateOfRegistrationField,
			[PartyFromField.name]: PartyFromField,
			[PartyToField.name]: PartyToField,
			[InstrumentAmountField.name]: InstrumentAmountField,
		},
		text: 'Instrument no. {{ requisitions.id.fields.instrumentNumber }} is a/an {{ requisitions.id.fields.encumbranceType }} registered on {{ requisitions.id.fields.registrationDate }} from {{ requisitions.id.fields.partyFrom }} in favour of {{ requisitions.id.fields.partyTo }} securing principal sum of {{ requisitions.id.fields.instrumentAmount.formatted }}.',
		requisitionText:
			'REQUIRED: On or before closing, production and registration of a good and valid discharge of this Mortgage.',
		source: '',
		isOnTitle: true,
	},
	{
		id: RequisitionPrecedentIds.NOTICE_OF_OPTION_TO_PURCHASE,
		closerDefault: true,
		version: 1,
		name: 'Notice of Option to Purchase',
		fields: {
			[InstrumentNumberField.name]: InstrumentNumberField,
			[EncumbranceTypeField.name]: EncumbranceTypeField,
			[DateOfRegistrationField.name]: DateOfRegistrationField,
			[PartyFromField.name]: PartyFromField,
			[PartyToField.name]: PartyToField,
		},
		text: 'Instrument no. {{ requisitions.id.fields.instrumentNumber }} is a/an {{ requisitions.id.fields.encumbranceType }} registered on {{ requisitions.id.fields.registrationDate }} from {{ requisitions.id.fields.partyFrom }} in favour of {{ requisitions.id.fields.partyTo }}.',
		requisitionText:
			'REQUIRED: On or before closing, deletion of this Notice of Option to Purchase from title to the subject property.',
		source: '',
		isOnTitle: true,
	},
	{
		id: RequisitionPrecedentIds.NOTICE_OF_SECURITY_INTEREST,
		closerDefault: true,
		version: 1,
		name: 'Notice of Security Interest',
		fields: {
			[InstrumentNumberField.name]: InstrumentNumberField,
			[EncumbranceTypeField.name]: EncumbranceTypeField,
			[DateOfRegistrationField.name]: DateOfRegistrationField,
			[PartyFromField.name]: PartyFromField,
			[PartyToField.name]: PartyToField,
			[InstrumentAmountField.name]: InstrumentAmountField,
		},
		text: 'Instrument no. {{ requisitions.id.fields.instrumentNumber }} is a/an {{ requisitions.id.fields.encumbranceType }} registered on {{ requisitions.id.fields.registrationDate }} from {{ requisitions.id.fields.partyFrom }} in favour of {{ requisitions.id.fields.partyTo }} securing principal sum of {{ requisitions.id.fields.instrumentAmount.formatted }}.',
		requisitionText:
			'REQUIRED: On or before closing, production and registration of a good and valid discharge of said Notice of Security Interest.',
		source: '',
		isOnTitle: true,
	},
	{
		id: RequisitionPrecedentIds.NOTICE_OF_SUBDIVISION_AGREEMENT,
		closerDefault: true,
		version: 1,
		name: 'Notice of subdivision agreement',
		fields: {
			[InstrumentNumberField.name]: InstrumentNumberField,
			[EncumbranceTypeField.name]: EncumbranceTypeField,
			[DateOfRegistrationField.name]: DateOfRegistrationField,
			[PartyFromField.name]: PartyFromField,
			[PartyToField.name]: PartyToField,
			[InstrumentAmountField.name]: InstrumentAmountField,
		},
		text: 'Instrument no. {{ requisitions.id.fields.instrumentNumber }} is a/an {{ requisitions.id.fields.encumbranceType }} registered on {{ requisitions.id.fields.registrationDate }} from {{ requisitions.id.fields.partyFrom }} in favour of {{ requisitions.id.fields.partyTo }} in the amount of {{ requisitions.id.fields.instrumentAmount.formatted }}.',
		requisitionText:
			'REQUIRED: On or before closing: \n a)production and delivery of evidence that all terms, conditions and obligations pursuant to the said Agreement have been complied with in full to date, and \n b)production and registration of a good and valid release from the said Agreement insofar as it affects the subject property.',
		source: '',
		isOnTitle: true,
	},
	{
		id: RequisitionPrecedentIds.NOTICE_OF_VENDORS_LIEN,
		closerDefault: true,
		version: 1,
		name: "Notice of Vendor's Lien",
		fields: {
			[InstrumentNumberField.name]: InstrumentNumberField,
			[EncumbranceTypeField.name]: EncumbranceTypeField,
			[DateOfRegistrationField.name]: DateOfRegistrationField,
			[PartyFromField.name]: PartyFromField,
			[PartyToField.name]: PartyToField,
			[InstrumentAmountField.name]: InstrumentAmountField,
		},
		text: 'Instrument no. {{ requisitions.id.fields.instrumentNumber }} is a/an {{ requisitions.id.fields.encumbranceType }} registered on {{ requisitions.id.fields.registrationDate }} from {{ requisitions.id.fields.partyFrom }} in favour of {{ requisitions.id.fields.partyTo }} in the amount of {{ requisitions.id.fields.instrumentAmount.formatted }}.',
		requisitionText:
			"REQUIRED: On or before closing, removal of this Vendor's Lien from title to the subject property.",
		source: '',
		isOnTitle: true,
	},
	{
		id: RequisitionPrecedentIds.OPTION_TO_PURCHASE,
		closerDefault: true,
		version: 1,
		name: 'Option to Purchase',
		fields: {
			[InstrumentNumberField.name]: InstrumentNumberField,
			[EncumbranceTypeField.name]: EncumbranceTypeField,
			[DateOfRegistrationField.name]: DateOfRegistrationField,
			[PartyFromField.name]: PartyFromField,
			[PartyToField.name]: PartyToField,
			[InstrumentAmountField.name]: InstrumentAmountField,
		},
		text: 'Instrument no. {{ requisitions.id.fields.instrumentNumber }} is a/an {{ requisitions.id.fields.encumbranceType }} registered on {{ requisitions.id.fields.registrationDate }} from {{ requisitions.id.fields.partyFrom }} in favour of {{ requisitions.id.fields.partyTo }} securing principal sum of {{ requisitions.id.fields.instrumentAmount.formatted }}.',
		requisitionText:
			'REQUIRED: On or before closing, deletion of this Option to Purchase from title to the subject property.',
		source: '',
		isOnTitle: true,
	},
	{
		id: RequisitionPrecedentIds.RESTRICTIVE_COVENANTS_APPLICATION_TO_ANNEX,
		closerDefault: true,
		version: 1,
		name: 'Restrictive Covenants Application to Annex',
		fields: {
			[InstrumentNumberField.name]: InstrumentNumberField,
			[EncumbranceTypeField.name]: EncumbranceTypeField,
			[DateOfRegistrationField.name]: DateOfRegistrationField,
			[PartyFromField.name]: PartyFromField,
			[PartyToField.name]: PartyToField,
		},
		text: 'Instrument no. {{ requisitions.id.fields.instrumentNumber }} is a/an {{ requisitions.id.fields.encumbranceType }} registered on {{ requisitions.id.fields.registrationDate }} from {{ requisitions.id.fields.partyFrom }} in favour of {{ requisitions.id.fields.partyTo }}.',
		requisitionText:
			'REQUIRED: On or before closing: \n a) production and delivery of evidence that the said Covenants have been complied with in full to date, and \n b) deletion of said Covenants from title to the subject property.',
		source: '',
		isOnTitle: true,
	},
	{
		id: RequisitionPrecedentIds.SEWER_AND_WATER,
		closerDefault: true,
		version: 1,
		name: 'Sewer and Water',
		fields: {},
		text: 'This property is serviced by a septic system and the water is provided by a well.',
		requisitionText:
			"REQUIRED: Production of all documentation relating to the septic system, including a Certificate of Installation and Approval and a Certificate of Use. \n Prior to closing the Seller's warranty, stated to survive closing,in the following terms: \n The Seller represents and warrants, to the best of the Seller's knowledge and belief, that at the time of installation: \n (1) all sewage systems serving the property are wholly within the setback requirements of the said property, and had received all required Certificates of Installation and Approval pursuant to the Environmental Protection Act; \n (2) all sewage systems serving the property had been constructed in accordance with the said Certificates of Installation and Approval; \n (3) all sewage systems serving the property had received all required Use permits under the said Act or any other legislation; and \n (4) all sewage systems serving the property have been maintained in good working order during the Seller's occupancy and will be in good working order on closing REQUIRED: Production of all documentation relating to the well, including a Potability Certificate.",
		source: '',
		isOnTitle: false,
	},
	{
		id: RequisitionPrecedentIds.SUBDIVISION_AGREEMENT,
		closerDefault: true,
		version: 1,
		name: 'Subdivision Agreement',
		fields: {
			[InstrumentNumberField.name]: InstrumentNumberField,
			[EncumbranceTypeField.name]: EncumbranceTypeField,
			[DateOfRegistrationField.name]: DateOfRegistrationField,
			[PartyFromField.name]: PartyFromField,
			[PartyToField.name]: PartyToField,
		},
		text: 'Instrument no. {{ requisitions.id.fields.instrumentNumber }} is a/an {{ requisitions.id.fields.encumbranceType }} registered on {{ requisitions.id.fields.registrationDate }} from {{ requisitions.id.fields.partyFrom }} in favour of {{ requisitions.id.fields.partyTo }}.',
		requisitionText:
			'REQUIRED: On or before closing: \n a) production and delivery of evidence that all terms, conditions and obligations pursuant to the said Agreement have been complied with in full to date, and \n b) production and registration of a good and valid release from the said Agreement insofar as it affects the subject property.',
		source: '',
		isOnTitle: true,
	},
	{
		id: RequisitionPrecedentIds.TRANSFER_OF_EASEMENT,
		closerDefault: true,
		version: 1,
		name: 'Transfer of Easement',
		fields: {
			[InstrumentNumberField.name]: InstrumentNumberField,
			[EncumbranceTypeField.name]: EncumbranceTypeField,
			[DateOfRegistrationField.name]: DateOfRegistrationField,
			[PartyFromField.name]: PartyFromField,
			[PartyToField.name]: PartyToField,
			[InstrumentAmountField.name]: InstrumentAmountField,
		},
		text: 'Instrument no. {{ requisitions.id.fields.instrumentNumber }} is a/an {{ requisitions.id.fields.encumbranceType }} registered on {{ requisitions.id.fields.registrationDate }} from {{ requisitions.id.fields.partyFrom }} in favour of {{ requisitions.id.fields.partyTo }} in the amount of {{ requisitions.id.fields.instrumentAmount.formatted }}.',
		requisitionText:
			'REQUIRED: On or before closing, production and registration of a Release of the said Transfer of Easement from the person entitled to use thereof and registration of the necessary application to delete the said easement from title to the subject property.',
		source: '',
		isOnTitle: true,
	},
	{
		id: RequisitionPrecedentIds.TRANSFER_OF_RIGHT_OF_WAY,
		closerDefault: true,
		version: 1,
		name: 'Transfer of Right of Way',
		fields: {
			[InstrumentNumberField.name]: InstrumentNumberField,
			[EncumbranceTypeField.name]: EncumbranceTypeField,
			[DateOfRegistrationField.name]: DateOfRegistrationField,
			[PartyFromField.name]: PartyFromField,
			[PartyToField.name]: PartyToField,
			[InstrumentAmountField.name]: InstrumentAmountField,
		},
		text: 'Instrument no. {{ requisitions.id.fields.instrumentNumber }} is a/an {{ requisitions.id.fields.encumbranceType }} registered on {{ requisitions.id.fields.registrationDate }} from {{ requisitions.id.fields.partyFrom }} in favour of {{ requisitions.id.fields.partyTo }} in the amount of {{ requisitions.id.fields.instrumentAmount.formatted }}.',
		requisitionText:
			'REQUIRED: On or before closing, production and registration of a Release of the said Transfer of Right of Way from the person entitled to use thereof and registration of the necessary application to delete the said right of way from title to the subject property.',
		source: '',
		isOnTitle: true,
	},
	{
		id: RequisitionPrecedentIds.RENTAL_OF_HOT_WATER_TANK,
		closerDefault: true,
		version: 1,
		name: 'Rental of Hot Water Tank',
		fields: {},
		text: 'In accordance with the Agreement of Purchase and Sale the hot water tank rental is to be assumed by the purchaser.',
		requisitionText: `REQUIRED: On or before closing, kindly provide our office with the provider's contact details, including name, phone number and account number in respect of the hot water tank rental. Or confirmation it is not rented.`,
		source: '',
		isOnTitle: false,
	},
	{
		id: RequisitionPrecedentIds.TAX_ARREARS,
		closerDefault: true,
		version: 1,
		name: 'Tax Arrears',
		fields: {
			[AmountOfTaxArrearsField.name]: AmountOfTaxArrearsField,
		},
		text: 'Enclosed is a copy of the tax certificate obtained by our office that shows arrears in the amount of {{requisitions.id.fields.amountOfTaxArrears}}',
		requisitionText:
			'REQUIRED: On or before closing, good and sufficient evidence that the outstanding amounts, or amounts due by closing, have been paid in full. Or in the alternative, your personal undertaking to pay the outstanding arrears, including any penalties or interest, from the proceeds due on closing and to provide proof of payment after closing.',
		source: '',
		isOnTitle: false,
	},
	{
		id: RequisitionPrecedentIds.SALE_BY_ESTATE,
		closerDefault: true,
		version: 1,
		name: 'Sale by Estate',
		fields: {
			[NameOfEstateField.name]: NameOfEstateField,
		},
		text: 'The Agreement of Purchase and Sale indicates that the property is being sold by the Estate of {{requisitions.id.fields.nameOfEstate}}.',
		requisitionText:
			'REQUIRED:  On or before closing, production and registration of: \n (i)    Notarial Copy of the Certificate of Probate for the Estate of {{requisitions.id.fields.nameOfEstate}}; \n (ii)   Transmission Application by the Personal Representative of the Estate of {{requisitions.id.fields.nameOfEstate}}; \n (iii)   Transfer by Personal Representative of the Estate of {{requisitions.id.fields.nameOfEstate}}.',
		source: '',
		isOnTitle: false,
	},
	{
		id: RequisitionPrecedentIds.NAME_DIFFERENT_ON_APS_AND_TITLE,
		closerDefault: true,
		version: 1,
		name: 'Name different on APS and Title',
		fields: {
			[NamesAsOnApsField.name]: NamesAsOnApsField,
			[NamesAsOnTitleField.name]: NamesAsOnTitleField,
		},
		text: 'As per the Agreement of Purchase and Sale the Vendor is listed as {{requisitions.id.fields.namesAsOnAps}} however our search of title shows the owner as {{requisitions.id.fields.namesAsOnTitle}}.',
		requisitionText:
			'REQUIRED: On or before closing, evidence that the vendor listed on the Agreement of Purchase and Sale has the authority to sell the property.',
		source: '',
		isOnTitle: false,
	},
	{
		id: RequisitionPrecedentIds.PRIVATE_MORTGAGE,
		closerDefault: true,
		version: 1,
		name: 'Charge (Private)',
		fields: {
			[InstrumentNumberField.name]: InstrumentNumberField,
			[EncumbranceTypeField.name]: EncumbranceTypeField,
			[DateOfRegistrationField.name]: DateOfRegistrationField,
			[PartyFromField.name]: PartyFromField,
			[PartyToField.name]: PartyToField,
			[InstrumentAmountField.name]: InstrumentAmountField,
		},
		text: 'Instrument No. {{requisitions.id.fields.instrumentNumber}} is a {{requisitions.id.fields.encumbranceType}} registered on {{requisitions.id.fields.registrationDate}} from {{requisitions.id.fields.partyFrom}} in favour of {{requisitions.id.fields.partyTo}} securing the principal sum of {{requisitions.id.fields.instrumentAmount}}',
		requisitionText:
			'REQUIRED: Production and registration of a good and valid discharge of this Mortgage. For a private mortgage we require actual discharge of the mortgage prior to registration. In the alternative we will accept a signed discharge statement with a signed acknowledgment and direction and draft discharge for registration and the Mortgagee’s Solicitor’s undertaking to hold funds until the mortgage is discharged.',
		source: '',
		isOnTitle: true,
	},
	{
		id: RequisitionPrecedentIds.TENANCIES_ASSUMED,
		closerDefault: true,
		version: 1,
		name: 'Tenancies Assumed',
		fields: {},
		text: 'The Agreement of Purchase and Sale provides that the purchaser is to assume the existing tenants at the property. Enclosed herewith is our form of Acknowledgement of Tenant to be completed and executed by all such tenants.',
		requisitionText: `REQUIRED: On or before closing: \n \n a)     Acknowledgement of tenant, duly completed so as to set out the terms of the existing tenancy, and signed by all tenants at the premises. Please provide, prior to closing, a draft of the duly completed acknowledgement(s) in the same form as will be provided on closing; \n b)    Written lease document, if any; \n c)    Notice to tenant, signed by the vendor, advising of the change of ownership and directing the tenant to make all future rental payments to the purchaser at the purchaser's address.`,
		source: '',
		isOnTitle: false,
	},
	{
		id: RequisitionPrecedentIds.MULTI_UNIT,
		closerDefault: true,
		version: 1,
		name: 'Multi-unit',
		fields: {},
		text: 'The Agreement of Purchase and Sale provides that this builiding on this property is used as a multi-unit residence. In order to be used as a multi-unit residence, the building must comply with the provisions of The Fire Protection and Prevention Act and the provisions of the Ontario Hydro electrical code.',
		requisitionText:
			'REQUIRED: A Certificate from the Fire Department certifying that the property complies with the Fire Protection and Prevention Act. \n FURTHER REQUIRED: A Certificate from the Electrical Safety Authority certifying that it complies with the Ontario Hydro code. \n We will require the said certificates on or before closing to establish that the subject multi-unit property may be lawfully continued as such.',
		source: '',
		isOnTitle: false,
	},
	{
		id: RequisitionPrecedentIds.CONDO_FEE_DIFFERENT_ON_APS_TO_STATUS_CERTIFICATE,
		closerDefault: true,
		version: 1,
		name: 'Condo fee different on APS to Status certificate',
		fields: {
			[CondoFeeAsApsField.name]: CondoFeeAsApsField,
			[CondoFeeAsOnStatusCertificateField.name]:
				CondoFeeAsOnStatusCertificateField,
		},
		text: 'As per the Agreement of Purchase and Sale the Condo fees are listed as {{requisitions.id.fields.condoFeeAsAps}}  however the status certificate lists them as {{requisitions.id.fields.condoFeeAsOnStatusCertificate}}.',
		requisitionText:
			'REQUIRED: On or before closing, a Statement of Adjustments which lists the correct condo fees.',
		source: '',
		isOnTitle: false,
	},
	{
		id: RequisitionPrecedentIds.PURCHASE_FROM_ESTATE,
		closerDefault: true,
		version: 1,
		name: 'Purchase from Estate',
		fields: {},
		text: 'The Agreement of Purchase and Sale shows the Vendor as being {{vendors.names}}. Our search of title reveals the registered owners of the subject property as {{property.primaryParcel.owners}}.',
		requisitionText: `REQUIRED: Production and registration of a Transfer by Name of Owners in favour of our {{plural client.count "client" "clients"}}. In the event that Owner is deceased, we shall require a Survivorship Application to be prepared and registered on title in advance of a Transfer in favour of our {{plural clients.count "client" "clients"}} from {{vendors.names}}. \n\n REQUIRED: We will require confirmation that a Transmission Application has been registered in advance of the Transfer by Personal Representative.`,
		source: '',
		isOnTitle: false,
	},
	{
		id: RequisitionPrecedentIds.TAXES_NOT_ASSESSED,
		closerDefault: true,
		version: 1,
		name: 'Taxes not assessed',
		fields: {
			[HoldbackAmountField.name]: HoldbackAmountField,
		},
		text: 'I enclose herewith a copy of the tax certificate from the {{jurisdictions.primary.name}}.  As you will note, the property has been assessed based on the land value only, and not based upon the value of the dwelling and land.',
		requisitionText: `REQUIRED: Your undertaking to holdback {{requisitions.id.fields.holdbackAmount}} from the proceeds of sale until a supplemental tax bill is issued from the {{jurisdictions.primary.name}}, at which point the held back funds would be used to pay your client's portion of the supplemental bill.`,
		source: '',
		isOnTitle: false,
	},
];
